import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

import { OrderService } from './order.service';
import { Observable } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { IncidentReporting } from '../../../../shared/objects/order/incidentReporting';

@Injectable()
export class IncidentReportingService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
  ) {}

  public add(incidentReporting: IncidentReporting) {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.put(
      `${environment.incidentReportingServiceUrl}/`,
      incidentReporting,
      { headers },
    );
  }

  public getIncidentsNumber(): Observable<any> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get(
      `${environment.incidentReportingServiceUrl}/getIncidentsNumber`,
      { headers },
    );
  }
}
